const css = `
.pcard{background:#111C2E;border:1px solid rgba(255,255,255,0.07);border-radius:14px;padding:22px;
  cursor:pointer;transition:all 0.25s;position:relative;overflow:hidden;}
.pcard:hover{border-color:rgba(0,194,255,0.3);transform:translateY(-2px);box-shadow:0 12px 40px rgba(0,0,0,0.4);}
.pcard::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,#1E7FD4,#0066FF);opacity:0;transition:opacity 0.2s;}
.pcard:hover::before{opacity:1;}
.pcard.elite::before{opacity:1;background:linear-gradient(90deg,#6DBE45,#FFD700);}
.pcard-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:14px;}
.avatar{width:50px;height:50px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-family:'Barlow Condensed',sans-serif;font-size:20px;font-weight:800;flex-shrink:0;}
.av-gold{background:rgba(245,166,35,0.15);color:#6DBE45;}
.av-blue{background:rgba(0,194,255,0.15);color:#1E7FD4;}
.av-green{background:rgba(0,230,118,0.15);color:#00E676;}
.pcard-meta{flex:1;padding-left:12px;}
.pcard-id{font-size:13px;font-weight:700;color:#F0F6FF;margin-bottom:1px;}
.pcard-spec{font-size:12px;color:#8899AA;}
.pcard-badges{display:flex;gap:5px;flex-wrap:wrap;margin-top:5px;}
.pcard-stats{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;
  margin:14px 0;padding:12px 0;border-top:1px solid rgba(255,255,255,0.06);border-bottom:1px solid rgba(255,255,255,0.06);}
.stat{text-align:center;}
.stat-v{font-family:'Barlow Condensed',sans-serif;font-size:20px;font-weight:700;color:#F0F6FF;}
.stat-v.ac{color:#1E7FD4;}
.stat-l{font-size:9px;color:#445566;text-transform:uppercase;letter-spacing:0.5px;margin-top:1px;}
.skills-row{display:flex;gap:5px;flex-wrap:wrap;margin-bottom:14px;}
.pcard-rate-row{display:flex;align-items:center;justify-content:space-between;}
.rate-big{font-family:'Barlow Condensed',sans-serif;font-size:26px;font-weight:800;color:#1E7FD4;}
.rate-big span{font-size:13px;font-weight:400;color:#8899AA;}
.market-cmp{font-size:11px;color:#8899AA;}
.market-cmp.below{color:#00E676;}
.market-cmp.above{color:#FF4757;}
.elite-tag{position:absolute;top:10px;right:12px;font-size:9px;font-weight:700;
  color:#6DBE45;letter-spacing:1px;text-transform:uppercase;}
`;

const COLORS = ['av-gold','av-blue','av-green'];

export default function ProviderCard({ provider: p, marketRate, onSelect }) {
  const diff  = p.rate_hr - (marketRate||90);
  const pct   = Math.abs(((diff / (marketRate||90)) * 100)).toFixed(0);
  const color = COLORS[parseInt(p.code_id?.replace('FF-',''))||0 % 3];

  return (<><style>{css}</style>
    <div className={`pcard${p.tier==='elite'?' elite':''}`} onClick={()=>onSelect(p)}>
      {p.tier==='elite' && <div className="elite-tag">★ Elite</div>}
      <div className="pcard-top">
        <div className={`avatar ${color}`}>{p.initials||'??'}</div>
        <div className="pcard-meta">
          <div className="pcard-id">{p.code_id}</div>
          <div className="pcard-spec">{p.specialty}</div>
          <div className="pcard-badges">
            {(p.certifications||[]).slice(0,1).map(c=><span key={c} className="badge badge-cert">{c}</span>)}
            {p.verified && <span className="badge badge-verified">✓ Verified</span>}
            {p.insured  && <span className="badge badge-insured">Insured</span>}
          </div>
        </div>
      </div>
      <div className="pcard-stats">
        <div className="stat"><div className="stat-v">{p.experience_years}yr</div><div className="stat-l">Exp</div></div>
        <div className="stat"><div className="stat-v ac">{p.avg_rating>0?p.avg_rating:'New'}</div><div className="stat-l">Rating</div></div>
        <div className="stat"><div className="stat-v">{p.job_count}</div><div className="stat-l">Jobs</div></div>
      </div>
      <div className="skills-row">
        {(p.skills||[]).slice(0,4).map(s=><span key={s} className="tag" style={{fontSize:11}}>{s}</span>)}
      </div>
      <div className="pcard-rate-row">
        <div>
          <div className="rate-big">${p.rate_hr}<span>/hr</span></div>
          <div className={`market-cmp${diff<-2?' below':diff>2?' above':''}`}>
            {diff<-2?`↓ ${pct}% below market`:diff>2?`↑ ${pct}% above market`:'At market rate'}
          </div>
        </div>
        <button className={`btn btn-sm ${p.tier==='elite'?'btn-gold':'btn-primary'}`}
          onClick={e=>{e.stopPropagation();onSelect(p);}}>
          Select →
        </button>
      </div>
    </div></>);
}
